import './Styles.scss';

class Multiselect {

    constructor(element) {
        this.element = element
        this.input = element.querySelector('.multiselect__input')
        this.inputValue = element.querySelector('.multiselect__input__value')
        this.dropdown = element.querySelector('.multiselect__dropdown')
        this.inputs = element.querySelectorAll('.form-check-input')
        this.count = element.querySelector('.multiselect__selected-count')
        let isCheckedOnLoad = false

        this.classes = {
            open:     'multiselect--open',
            selected: 'multiselect--has-selected'
        }

        // Init event listeners
        this.input.addEventListener('click', this.handleInputClick)
        this.dropdown.addEventListener('click', () => event.stopPropagation())
        document.addEventListener('click', this.handleOutsideClick)

        this.inputs.forEach(input => {
            input.addEventListener('change', this.handleInputChange)

            if (input.checked) {
                isCheckedOnLoad = true
            }
        })

        if (isCheckedOnLoad) {
            this.handleInputChange()
        }
    }

    handleInputClick = () => {
        event.stopPropagation()

        if (!this.element.classList.contains(this.classes.open)) {
            document.querySelectorAll('.multiselect').forEach(select => {
                select.classList.remove(this.classes.open)
            })
        }

        this.element.classList.toggle(this.classes.open)
    }

    handleOutsideClick = () => {
        this.element.classList.remove(this.classes.open)
    }

    handleInputChange = () => {
        let selectedString = ''
        let checkedCount = 0

        this.inputs.forEach(input => {
            input.removeEventListener('click', this.uncheckRadio)

            if (input.checked) {
                checkedCount++

                if (selectedString !== '') {
                    selectedString += ', '
                }

                let formCheck = input.closest('.form-check')
                selectedString += formCheck.querySelector('.form-check-label').innerHTML

                if (input.getAttribute('data-allow-uncheck')) {
                    input.addEventListener('click', this.uncheckRadio)
                }
            }
        })

        if (checkedCount > 0) {
            this.element.classList.add(this.classes.selected)
        } else {
            selectedString = this.input.dataset.placeholder
            this.element.classList.remove(this.classes.selected)
        }

        this.inputValue.innerText = selectedString
        this.count.innerText = checkedCount
    }

    uncheckRadio = function() {
        this.checked = false
        this.dispatchEvent(new Event('change'))
    }
}

window.addEventListener('load', function() {
    const multiselects = document.querySelectorAll('.multiselect')

    Array.from(multiselects).forEach((element, index) => {
        new Multiselect(element)
    })
})